import { type FC } from "react";
import { useFormContext } from "react-hook-form";
import { type FormValues } from "@userFrontend/features/promotion/components/Assessment/schema";
import { Presentation } from "./Presentation";

export const ContactAndPasswordFields: FC = () => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<FormValues>();

  const email = watch("mailAddress");
  const password = watch("password");

  return (
    <Presentation
      emailValue={email}
      passwordValue={password}
      emailErrorMessage={errors.mailAddress?.message}
      passwordErrorMessage={errors.password?.message}
      onChangeEmail={(e) =>
        setValue("mailAddress", e.target.value, {
          shouldValidate: false,
          shouldDirty: true,
        })
      }
      onChangePassword={(e) =>
        setValue("password", e.target.value, {
          shouldValidate: false,
          shouldDirty: true,
        })
      }
    />
  );
};
